// extracted by mini-css-extract-plugin
export default {"wrapper":"vba-z","play":"wba-z"};